export const selectFilter=(filter)=>{
    return{
        type:'SELECT_FILTER',
        payload:filter
    }
}